import { jsx as _jsx } from "react/jsx-runtime";
const React = require("react");
export const SearchIcon = /*#__PURE__*/ _jsx("svg", {
    className: "form__icon",
    width: "20px",
    height: "20px",
    "aria-hidden": "true",
    children: /*#__PURE__*/ _jsx("use", {
        xlinkHref: "#icon--search"
    })
});
